import Vue from 'vue'
import TagApi from '../apis/tag'
export const state = () => ({
  id: "",
  name: "",
  total_count: "",
  items: [],
  autocomplete_items: []
});
export const actions = {
  async search({ commit, state }) {
    return await TagApi.search(state)
  },
}
export const mutations = {
  setId(state, id){
    state.name = id
  },
  setName(state, name){
    state.name = name
  },
  setTotalCount(state, total_count){
    state.total_count = total_count
  },
  setAutocompleteItems(state, items){
    state.autocomplete_items = items
  },
  setItems(state, items){
    state.items = items
  },
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
